import axios from 'axios'
import qs from 'qs'
import { Message } from 'element-ui'
import { mystorage } from '../utils/myStorage'
import router from "../router";

let baseurl = process.env.BASE_API || '/yt_api'

// ======================== 拦截器 ========================

// http request 拦截器：统一注入 token
axios.interceptors.request.use(
  config => {
    const token = mystorage.get('token')
    if (token) {
      config.headers.Authorization = token
    } else if (!config.url.includes('/admin/login')) {
      router.push('/login')
    }
    // 设置请求超时时间为 10 分钟（600000ms），支持大文件导入等耗时操作
    config.timeout = 600000
    return config
  },
  err => Promise.reject(err)
)

// http response 拦截器：统一错误处理 + 401 自动登出
axios.interceptors.response.use(
  response => response,
  error => {
    const status = error.response && error.response.status
    if (status === 401) {
      mystorage.remove('token')
      router.push('/login')
      return Promise.reject(error)
    }
    const msg = codeMessage[status] || '网络连接异常，请稍后再试~'
    Message({ type: 'error', message: msg })
    return Promise.reject(error)
  }
)

const codeMessage = {
  200: '服务器成功返回请求的数据。',
  201: '新建或修改数据成功。',
  202: '一个请求已经进入后台排队（异步任务）。',
  204: '删除数据成功。',
  400: '发出的请求有错误，服务器没有进行新建或修改数据的操作。',
  401: '用户没有权限（令牌、用户名、密码错误）。',
  403: '用户得到授权，但是访问是被禁止的。',
  404: '发出的请求针对的是不存在的记录，服务器没有进行操作。',
  406: '请求的格式不可得。',
  410: '请求的资源被永久删除，且不会再得到的。',
  422: '当创建一个对象时，发生一个验证错误。',
  500: '服务器发生错误，请检查服务器。',
  502: '网络连接异常，请稍后再试~',
  503: '服务不可用，服务器暂时过载或维护。',
  504: '网络连接超时，请稍后再试~',
}

// ======================== 请求方法 ========================

// GET 请求（参数拼接在 URL 查询串中）
export function getRequest(apiPath, params) {
  const url = baseurl + apiPath
  return axios.get(url, { params }).then(res => res.data)
}

// POST 请求 - JSON 格式提交（后端 @RequestBody 接收）
export function postRequest(apiPath, params) {
  const url = baseurl + apiPath
  return axios.post(url, params, {
    headers: { Accept: 'application/json', 'Content-Type': 'application/json' }
  }).then(res => res.data)
}

// POST 请求 - 表单格式提交（后端 @RequestParam 接收）
export function postFormRequest(apiPath, params) {
  const url = baseurl + apiPath
  return axios.post(url, qs.stringify(params), {
    headers: { Accept: 'application/json', 'Content-Type': 'application/x-www-form-urlencoded' }
  }).then(res => res.data)
}

// ======================== 文件下载 ========================

// 通用文件下载
export function downloadFile(fileUrl, fileName) {
  const link = document.createElement('a')
  link.style.display = 'none'
  link.href = fileUrl
  link.setAttribute('download', fileName)
  document.body.appendChild(link)
  link.click()
  document.body.removeChild(link)
}

// 导出请求（Promise 风格）
export function exportRequest(apiPath, params, fileName, fileType) {
  fileName = fileName || '导出文件'
  fileType = fileType || 'xls'
  const url = baseurl + apiPath
  return axios.post(url, params, {
    headers: { Accept: 'application/json', 'Content-Type': 'application/json' }
  }).then(res => {
    if (res.status === 200 && res.data && res.data.data) {
      downloadFile(res.data.data, `${fileName}.${fileType}`)
    }
    return res.data
  })
}

// ======================== HttpService 对外暴露 ========================

export const HttpService = {
  // GET 请求
  get: function (url, param) {
    return getRequest(url, param)
  },

  /**
   * POST 请求 - JSON 格式（最常用，对应后端 @RequestBody）
   * 注意：历史原因 postForm 实际发送的是 JSON，此处保持兼容
   */
  postForm: function (url, param) {
    return postRequest(url, param)
  },

  /**
   * POST 请求 - JSON 格式（postJson 是 postForm 的语义修正别名，推荐使用）
   */
  postJson: function (url, param) {
    return postRequest(url, param)
  },

  /**
   * POST 请求 - 表单格式（对应后端 @RequestParam）
   */
  post: function (url, param) {
    return postFormRequest(url, param)
  },

  exportRequest: function (url, param, fileName, fileType, successCallback, errorCallback) {
    const promise = exportRequest(url, param, fileName, fileType)
    if (successCallback) {
      promise.then(res => successCallback(res)).catch(err => errorCallback && errorCallback(-1, err.message))
    }
    return promise
  },

  download: function (url, fileName) {
    return downloadFile(url, fileName || '下载文件')
  },

  /**
   * 后端返回文件地址后触发下载（导出类接口通用）
   * 未传文件名时自动从 URL 中提取，用于 this.$http.downloads(res.data) 调用场景
   */
  downloads: function (fileUrl, fileName) {
    if (!fileUrl) {
      Message({ type: 'warning', message: '下载地址为空' })
      return
    }
    if (!fileName) {
      fileName = decodeURIComponent(fileUrl.split('?')[0].substring(fileUrl.split('?')[0].lastIndexOf('/') + 1)) || '下载文件'
    }
    return downloadFile(fileUrl, fileName)
  },

  baseurl
}



// WEBPACK FOOTER //
// ./src/http/HttpService.js